import { useEffect, useState } from "react";

import { DESKTOP_DESIGN_WIDTH } from "constants/common";

/**
 * Returns a scale factor that shrinks a fixed-width canvas to fit the current
 * viewport, capped at 1 (never scales up). Applied via CSS `zoom` on the
 * desktop layout wrapper so the 1440px design fits laptops whose usable width
 * is below 1440px without producing a horizontal scrollbar.
 */
const useFitScale = (designWidth: number = DESKTOP_DESIGN_WIDTH): number => {
  const getScale = (): number => {
    if (typeof window === "undefined") return 1;
    return Math.min(1, window.innerWidth / designWidth);
  };

  const [scale, setScale] = useState<number>(getScale);

  useEffect(() => {
    const update = (): void => setScale(getScale());

    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [designWidth]);

  return scale;
};

export default useFitScale;
